<script>
    export let actions = false
    export let classes = ''
</script>

<style>
    .ListItem {
        background-color: var(--forge-primary-bg);
        border-radius: 3px;
        font-size: 14px;
        margin-bottom: 3px;
        padding: 5px 15px;
        position: relative;
        box-shadow: 0 0 3px #aabed0;
    }
    .ListItem .hover {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background-color: rgb(121, 172, 199, .21);
        display: none;
    }
    .ListItem:hover .hover {
        display: block;
    }
    .ListItem .hover .ctrls {
        position: absolute;
        width: 100%;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        text-align: right;
        padding: 0 10px;
    }
    .ListItem :global(.lbl) {
        font-weight: 600;
    }
    .ListItem :global(.txt) {
        font-size: 12px;
        color: var(--text-secondary);
        line-height: 14px;
    }
    .ListItem.with-icon {
        padding: 5px 15px 5px 0;
    }
    .ListItem.with-icon :global(.icon), 
    .ListItem.with-icon :global(.meta) {
        float: left;
    }
    .ListItem.with-icon :global(.icon) {
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
    }
    .ListItem.with-icon :global(.meta) {
        width: calc(100% - 40px);
    }
</style>

<div class="ListItem {classes}" on:click>
    <slot></slot>
    {#if actions}
        <div class="hover">
            <div class="ctrls">
                <slot name="actions"> </slot>
            </div>
        </div>
    {/if}
</div>